import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {Auth} from './helpers'
import Toasted from 'vue-toasted';
import VModal from 'vue-js-modal'

Auth.fetchUser()

Vue.config.productionTip = false

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { createProvider } from './vue-apollo'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faTimesCircle, faCheckCircle)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(Toasted)
Vue.use(VModal, { dialog: true })

new Vue({
  el: '#app',
  router,
  template: '<App/>',
  apolloProvider: createProvider(),
  render: h => h(App)
})